import PropTypes from "prop-types";

import { t } from "../../services";
import { colors, strCode } from "../../consts";

import {
  FlexContainers,
  Heading5,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../components";
import { ChangesNotSavedOption, ChangesNotSavedOptions } from "./styled";

const ChangesNotSavedModal = ({
  active,
  setActive,
  consentVersionTitle,
  onDiscard,
  onSaveDraft,
  onSaveAndContinue
}) => {
  return (
    <Modal
      id="changes-not-saved-modal"
      active={active}
      setActive={setActive}
      modalHeader={<Heading5>{t(strCode.CHANGES_NOT_SAVED_TITLE)}</Heading5>}>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={24} maxWidth={630}>
        <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={12} alignItems="start">
          <Paragraph2
            style={{ color: colors.RAISIN_70 }}
            dangerouslySetInnerHTML={{
              __html: t(strCode.CHANGES_NOT_SAVED_INFO, { version: consentVersionTitle })
            }}></Paragraph2>

          <ChangesNotSavedOptions>
            <ChangesNotSavedOption>
              {t(strCode.CHANGES_NOT_SAVED_LEAVE_OPTION)}
            </ChangesNotSavedOption>

            <ChangesNotSavedOption>
              {t(strCode.CHANGES_NOT_SAVED_SAVE_DRAFT_OPTION)}
            </ChangesNotSavedOption>

            <ChangesNotSavedOption>
              {t(strCode.CHANGES_NOT_SAVED_ACTIVATE_OPTION)}
            </ChangesNotSavedOption>

            <ChangesNotSavedOption>
              {t(strCode.CHANGES_NOT_SAVED_CONTINUE_OPTION)}
            </ChangesNotSavedOption>
          </ChangesNotSavedOptions>

          <Paragraph2 style={{ color: colors.RAISIN_70 }}>
            {t(strCode.CHANGES_NOT_SAVED_WARNING)}
          </Paragraph2>
        </WrapperContainer>

        <WrapperContainer Container={FlexContainers.FlexRowEnd} width="100%" gap={8}>
          <SmallButton secondary onClick={onDiscard}>
            {t(strCode.DISCARD_CHANGES_TITLE)}
          </SmallButton>

          <SmallButton
            secondary
            onClick={() => {
              setActive(false);
              onSaveDraft();
            }}>
            {t(strCode.SAVE_DRAFT_TITLE)}
          </SmallButton>

          <SmallButton
            onClick={() => {
              setActive(false);
              onSaveAndContinue();
            }}>
            {t(strCode.SAVE_AND_ACTIVATE_BTN)}
          </SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

ChangesNotSavedModal.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  consentVersionTitle: PropTypes.string.isRequired,
  onDiscard: PropTypes.string.isRequired,
  onSaveDraft: PropTypes.string.isRequired,
  onSaveAndContinue: PropTypes.string.isRequired
};

export default ChangesNotSavedModal;
